<template>
    <ContainerLayout page="0" :padding="false">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
                <div class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link"
                            @click.prevent="readAll">
                            <small
                                :class="notifications.filter((notification) => notification.read == false).length > 0 ? 'text-main font-weight-bold' : 'text-muted'">
                                {{ $t('Read All') }}
                            </small>
                        </router-link>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div v-if="loaded_data" class="content px-1">
            <div v-if="!notifications || notifications.length == 0"
                class="d-flex flex-column justify-content-center align-items-center text-center p-3">
                <img id="img-card" class="img-card" src="@/assets/images/logo-empty.png" />
                <label class="mt-4 mb-1 font-weight-bold">{{ $t('No notifications yet!') }}</label>
                <label class="text-muted">{{ $t('Stay tuned for some exciting information soon!') }}</label>
            </div>
            <div v-else>
                <div v-for="(notification, index) in notifications" :key="index"
                    class="d-flex flex-row justify-content-between align-items-center mb-1" style="cursor: pointer;"
                    @click.prevent="openNotification(notification)">
                    <div class="w-100 card"
                        style="border-radius: 0.25rem; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;"
                        :style="notification.read == false ? ' border: 2px solid #275D93;' : ' border: 1.5px solid rgba(0,0,0,.125);'">
                        <div class="d-flex flex-row p-3">
                            <div class="d-flex justify-content-start mt-1">
                                <div class="circle-icon">
                                    <div class="circle-icon-container">
                                        <img v-if="notification.image_url" class="circle-icon-image"
                                            :src="notification.image_url" />
                                        <font-awesome-icon v-else class="circle-icon-image" icon="bell"
                                            :class="notification.read == false ? 'text-main' : 'text-muted'" />
                                    </div>
                                </div>
                            </div>
                            <div class="ml-3">
                                <div class="w-100 d-flex flex-column">
                                    <small class="font-weight-bold"
                                        :class="notification.read == false ? 'text-main' : 'text-muted'">{{
                                            notification.current_title }}</small>
                                    <small>
                                        {{ notification.current_description }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content px-1">

        </div>
    </ContainerLayout>
</template>

<script>
import ContainerLayout from "../ContainerLayout.vue";
import NotificationService from "@/services/notification.service";

export default {
    name: "CartList",
    components: {
        ContainerLayout,
    },
    data() {
        return {
            loaded_data: false,
            loading: false,
            notifications: [],
        };
    },
    setup() {
        //
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
    },
    created() {
        this.loaded_data = false;
        this.loading = true;
        let loader = this.$loading.show();
        this.loadData(loader);
    },
    methods: {
        goBack() {
            this.navigateBackOrHome();
        },

        loadData(loader) {
            NotificationService.getAllByUserId(this.currentUser.id)
                .then((response) => {
                    this.loaded_data = true;
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.notifications = response.data.data;
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error').then(() => {
                            this.goBack();
                        });
                    }
                })
                .catch((error) => {
                    this.loaded_data = true;
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                        this.goBack();
                    });
                });
        },

        openNotification(notification) {
            NotificationService
                .read(notification.id, this.currentUser.id)
                .then((response) => {
                    if (response.data.status == 'success') {
                        notification.read = true;

                        if (notification.frontend_url) {
                            this.$router.push(notification.frontend_url);
                        } else {
                            // this.$router.push({
                            //     name: 'NotificationDetail',
                            //     params: {
                            //         id: notification.id
                            //     }
                            // });
                        }
                    } else {
                        //
                    }
                })
                .catch(() => {
                    //
                });
        },

        readAll() {
            if (this.notifications.filter((notification) => notification.read == false).length > 0) {
                NotificationService
                    .readAllByUserId(this.currentUser.id)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.notifications.forEach((notification) => {
                                notification.read = true;
                            });
                        } else {
                            //
                        }
                    })
                    .catch(() => {
                        //
                    });
            }
        },
    }
};
</script>

<style scoped>
.circle-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    overflow: hidden;
}

.circle-icon-container {
    width: 100%;
    height: 100%;
    position: relative;
    transform: scale(0.8);
}

.circle-icon-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
    top: 0;
    left: 0;
}
</style>